export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;
export const dt = (d) =>
  d
    ? new Date(d).toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "-";

// Wallet me totalBalance na ho to deposit + winning ko total maante hain
export const walletTotal = (w) =>
  w
    ? w.totalBalance != null
      ? Number(w.totalBalance)
      : Number(w.depositBalance || 0) + Number(w.winningBalance || 0)
    : 0;

// "11:38 21-10-26" (HH:MM DD-MM-YY) - bet history modal ke liye
export const dtShort = (d) => {
  if (!d) return "-";
  const x = new Date(d);
  if (Number.isNaN(x.getTime())) return "-";
  const p = (n) => String(n).padStart(2, "0");
  return `${p(x.getHours())}:${p(x.getMinutes())} ${p(x.getDate())}-${p(x.getMonth() + 1)}-${String(x.getFullYear()).slice(-2)}`;
};
